import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalConfigurationDetail extends BaseModelAPI {
	static entity = 'approvalconfigurationdetail';
	static entityName = 'approvalconfigurationdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.approvalConfigurationId = '';
			this.approvalConfiguration = {};
			this.approverTypeId = '';
			this.approverType = {};
			this.approvalStructureId = '';
			this.approvalStructure = {};
			this.approverLevel = 0;
			this.approverUserNameId = '';
			this.approverUserName = {};
			this.storedProcedureName = '';
			this.approvalType = '';
			this.configurationContent = '';
			this.isSendNotification = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}